import {
    AmexPayment,
    BancontactPayment,
    BoletoPayment,
    DiscoverPayment,
    EloPayment,
    HipercardPayment,
    IdealPayment,
    MaestroPayment,
    MastercardPayment,
    MonerisPayment,
    Money,
    OxxoPayment,
    PagofacilPayment,
    PaypalPayment,
    RapipagoPayment,
    SepaPayment,
    SofortPayment,
    VisaDebitPayment,
    VisaPayment,
} from '@eb/eds-iconography';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import { PaymentConstraintName } from './enums';

interface PaymentConstraintVariant {
    userString: string | GenericLazyString;
    icon?: React.ReactNode;
}
export const PAYMENT_CONSTRAINT_VARIANTS: Record<
    PaymentConstraintName,
    PaymentConstraintVariant
> = {
    [PaymentConstraintName.AMEX]: {
        userString: 'American Express',
        icon: <AmexPayment />,
    },
    [PaymentConstraintName.ADYEN_POS_PAYMENT]: {
        userString: 'Adyen POS Payment',
    },
    [PaymentConstraintName.BOLETO_BANCARIO]: {
        userString: 'Boleto Bancario',
        icon: <BoletoPayment />,
    },
    [PaymentConstraintName.BARCODE]: {
        userString: gettext('Pay in cash with Rapipago or Pagofacil'),
        icon: <Money />,
    },
    [PaymentConstraintName.BRAINTREE_PAYPAL]: {
        userString: 'Paypal',
        icon: <PaypalPayment />,
    },
    [PaymentConstraintName.CREDIT_CARD]: {
        userString: gettext('Credit Card'),
    },
    [PaymentConstraintName.DEBIT_CARD]: {
        userString: gettext('Debit Card'),
    },
    [PaymentConstraintName.DINERS_CLUB]: {
        userString: gettext('Diners Club'),
    },
    [PaymentConstraintName.DISCOVER]: {
        userString: 'Discover',
        icon: <DiscoverPayment />,
    },
    [PaymentConstraintName.ELO]: {
        userString: 'Elo',
        icon: <EloPayment />,
    },
    [PaymentConstraintName.HIPERCARD]: {
        userString: 'Hipercard',
        icon: <HipercardPayment />,
    },
    [PaymentConstraintName.IDEAL]: {
        userString: 'iDEAL',
        icon: <IdealPayment />,
    },
    [PaymentConstraintName.MAESTRO]: {
        userString: 'Maestro',
        icon: <MaestroPayment />,
    },
    [PaymentConstraintName.MAESTRO_BANCONTACT]: {
        userString: 'Maestro Bancontact',
        icon: <BancontactPayment />,
    },
    [PaymentConstraintName.MASTERCARD]: {
        userString: 'Mastercard',
        icon: <MastercardPayment />,
    },
    [PaymentConstraintName.MERCADO_PAGO]: {
        userString: 'Mercado Pago',
    },
    [PaymentConstraintName.MONERIS]: {
        userString: 'Moneris',
        icon: <MonerisPayment />,
    },
    [PaymentConstraintName.NARANJA]: {
        userString: 'Naranja',
    },
    [PaymentConstraintName.NATIVA]: {
        userString: 'Nativa',
    },
    [PaymentConstraintName.OXXO]: {
        userString: 'OXXO',
        icon: <OxxoPayment />,
    },
    [PaymentConstraintName.PAGOFACIL]: {
        userString: 'Pago Fácil',
        icon: <PagofacilPayment />,
    },
    [PaymentConstraintName.RAPIPAGO]: {
        userString: 'Rapipago',
        icon: <RapipagoPayment />,
    },
    [PaymentConstraintName.SEPA_DIRECT_DEBIT]: {
        userString: 'Sepa Direct Debit',
        icon: <SepaPayment />,
    },
    [PaymentConstraintName.SOFORT]: {
        userString: 'Sofort',
        icon: <SofortPayment />,
    },
    [PaymentConstraintName.VISA]: {
        userString: 'Visa',
        icon: <VisaPayment />,
    },
    [PaymentConstraintName.VISA_DEBIT]: {
        userString: gettext('Visa Debit Card'),
        icon: <VisaDebitPayment />,
    },
};
